import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

// COMPONENTS
import { CanOrNotFound } from 'permissions';
import DepartmentsCard from './components/DepartmentsCard.component';

// STYLES
import { SettingsPageContent } from 'styles/settings';

// CONSTANTS
import { DotAppRoute, FleetSettingsSideMenuItem, UserPermission } from 'constants/common';

// HOOKS
import { useAppDispatch } from 'hooks/store';

// THUNKS
import { getDealershipDepartments } from 'services/DealershipSettings/thunks';

const Departments = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getDealershipDepartments());
  }, []);

  return (
    <CanOrNotFound I={UserPermission.VIEW} a={DotAppRoute.SETTINGS} field={FleetSettingsSideMenuItem.DEPARTMENTS}>
      <SettingsPageContent constraintToScreenHeight>
        <Helmet>
          <title>
            {intl.formatMessage({
              id: 'views.Settings.helmetTitle',
            })}
          </title>
          <meta
            name="settings"
            content={intl.formatMessage({
              id: 'views.Settings.helmetDescription',
            })}
          />
        </Helmet>
        <DepartmentsCard />
      </SettingsPageContent>
    </CanOrNotFound>
  );
};

export default Departments;
